module.exports = __webpack_public_path__ + "975fb8d6f1ebc2bed764d2286c7eeb92.pdf";